import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CommonModule, NgClass, NgStyle} from "@angular/common";
import {
    TypographyPreviewComponent,
    TypographyPreviewModel
} from "@white-label/components/white-label/typography-preview/typography-preview.component";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {DynamicScaleDirective} from "@cybfed/core/utils/dynamic-scale.directive";
import {customSetTimeout} from "@cybfed/core/helpers/overrided-timers";
import {CrowdfundingProgressFormatPipe} from "@cybfed/shared/pipes/crowdfunding-progress-format.pipe";

export class CrowdFundingDesignModel {
    height = 20;
    showMask = false;
    vertical = false;
    maskBackgroundColor = false;
    borderRadius = 29;
    progressFormat= "onlyPercent";
    border = 2;
    notFilledColor = "linear-gradient(246deg, #3d3d3d, #878787)";
    filledColor = "linear-gradient(293deg, #e72269, #52001e)";
    showTimePosition = "hide";
    stylesForTime = new TypographyPreviewModel();
    showGoalPosition = "top";
    stylesForGoal = new TypographyPreviewModel();
    showBorderTexts = true;
    showTotalTextPosition = "top";
    stylesForTotalText = new TypographyPreviewModel();
}

export class CrowdFundingDataModel {
    collectedMoney = 50;
    endDate = 0;
    status = "active";
    targetValue = 100;
    title = 'Test';
    _id = "test";
}

@Component({
    selector: 'white-label-crowdfunding-render',
    standalone: true,
    imports: [
        TypographyPreviewComponent,
        CurrencyPipe,
        NgStyle,
        NgClass,
        DynamicScaleDirective,
        CrowdfundingProgressFormatPipe
    ],
    templateUrl: './crowdfunding-render.component.html',
    styleUrl: './crowdfunding-render.component.scss'
})
export class CrowdfundingRenderComponent implements OnChanges{
    @Input() styles: CrowdFundingDesignModel = new CrowdFundingDesignModel();
    @Input() data: CrowdFundingDataModel = new CrowdFundingDataModel();
    @Input() currency: string = 'AMD';
    @Input() devMode: boolean = false;

    @Input() collectedMoney: number = this.data.collectedMoney;
    rerender: boolean = false;

    protected readonly Math = Math;

    constructor() {
    }


    ngOnChanges(changes: SimpleChanges): void {
        if(changes['collectedMoney'] || changes['styles']) {
            this.rerender = true;
            customSetTimeout(() => {
                this.rerender = false;
            },1)
        }
    }



}
